export const DarkenColor = (color: string, amount: number): string => {
  const clamp = (value: number) => Math.max(0, Math.min(255, value))
  const match = color.replace(/^#/, '').match(/.{2}/g)

  if (!match) {
    throw new Error('Invalid color format')
  }

  const [r, g, b] = match.map((hex) => parseInt(hex, 16))

  const darkened = [clamp(r - amount), clamp(g - amount), clamp(b - amount)]

  return `#${darkened.map((val) => val.toString(16).padStart(2, '0')).join('')}`
}
